import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { BaseService } from './base.service';
import { getParsedError } from './error-handler-factory.service';
import { ExportRequest } from '../components/odata-filter/models/export-request';
import { ApiVersions } from './api-version';
import { ViewContext } from '../components/odata-filter/models/view-context';

const exportPaths: Record<ViewContext, string> = {
  [ViewContext.People]: 'export/people',
  [ViewContext.Teams]: 'export/teams',
  [ViewContext.TeamRosters]: 'export/team-rosters',
  [ViewContext.TeamSurvey]: 'export/team-surveys',
  [ViewContext.Evaluations]: 'export/evaluations',
  [ViewContext.Forms]: 'export/forms',
  [ViewContext.PersonScenarioReport]: 'export/person-scenario',
  [ViewContext.AllCredentialingDetailsReport]: 'export/person-credential',
  [ViewContext.CredentialingDetailsReport]: 'export/person-credential',
  [ViewContext.AllPaymentRecordsReport]: 'export/payment-records',
  [ViewContext.CredentialPaymentRecordsReport]: 'export/payment-records',
  [ViewContext.PaymentSummaryReport]: 'export/payment-summary',
  [ViewContext.AllInvoiceReport]: 'export/all-invoices',
  [ViewContext.OpportunityBoardReport]: 'export/opportunity-board',
  [ViewContext.PersonCredentialApplicationReport]: 'export/person-credential-application',
  [ViewContext.AllTeamCredentialingDetailsReport]: 'export/team-credential',
  [ViewContext.TeamCredentialingDetailsReport]: 'export/team-credential',
  [ViewContext.InProgressEntityCredentialApplications]: 'export/in-progress-credential-application',
  [ViewContext.TeamCredentialApplicationReport]: 'export/team-credential-application',
  [ViewContext.TeamScenarioReport]: 'export/team-scenario',
  //assuming these all do exports some other way?
  [ViewContext.TeamBench]: '',
  [ViewContext.OpportunityBoard]: '',
  [ViewContext.TeamFilter]: '',
  [ViewContext.TeamPageRosterDetail]: ''
};

@Injectable({
  providedIn: 'root'
})
export class ExportService extends BaseService {
  constructor() {
    super();
  }
  /** return false and pops snack error if an error occurs */
  public async customExportRequest(
    oDataQuery: string,
    templateId: string,
    viewContext: ViewContext
  ): Promise<boolean> {
    const payload = JSON.stringify({
      templateId,
      oDataQuery: `${this.getBaseApiUrl(ApiVersions.v1_0)}${oDataQuery}`,
      viewContext
    });
    try {
      return await lastValueFrom(
        this.post('export/custom-report', payload, null, ApiVersions.v0_1, true)
      );
    } catch (e) {
      this.openSnackBar(getParsedError(e).message, false);
      return false;
    }
  }

  public async FormResponsesExportPDFRequest(formId: string): Promise<boolean> {
    const payload = JSON.stringify(formId);
    try {
      return await lastValueFrom(
        this.post('export/zip-form-responses-pdf', payload, null, ApiVersions.v0_1, true)
      );
    } catch (e) {
      this.openSnackBar(getParsedError(e).message, false);
      return false;
    }
  }

  public exportRequest(request: ExportRequest, viewContext: ViewContext): Promise<any> {
    const path = exportPaths[viewContext];
    if (!path) {
      throw new Error(`No export path defined for view context ${viewContext}`);
    }

    const payload = JSON.stringify({
      oDataQuery: `${this.getBaseApiUrl(ApiVersions.v1_0)}${request.oDataQuery}`,
      columns: request.columns
    });

    return lastValueFrom(this.post(path, payload));
  }
}
